import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe que se encarga de poner unidad al numero
 */
@Pipe({
    name: 'typeNumber',
    standalone: false
})
export class TypeNumberPipe implements PipeTransform {
  /**
   * Constructor
   *
   * @param decimalPipe pipe de decimales
   */
  constructor(private decimalPipe: DecimalPipe) { }

  /**
   * Transforma el numero con la unidad indicada
   *
   * @param value valor a transformar
   * @param type tipo de unidad
   * @returns valor modificado con su unidad
   */
  transform(value: number, type: string) {
    value = value ? value : 0;
    switch (type) {
      case 'k':
        return `${value / 1000}k`;
      case 'lks':
        return `${value / 1000} Lks`;
      case 'dolar':
        return `$${value}`;
      case 'milesDolar':
        return `$${value / 1000}`;
      case 'sinMiles':
        return `${value / 1000}`;
      case 'miles':
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      default:
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
}
